import axios, { AxiosError } from "axios";
import { useMutation } from "react-query";

// eslint-disable-next-line
const DeleteTagApiService = async (request: number): Promise<boolean> => {
  const url = `/employertag/${request}/`;
  const { data } = await axios.delete(url);
  return data;
};

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const useDeleteTagApiService = () =>
  useMutation<boolean, AxiosError, number>(
    DeleteTagApiService, {
      mutationKey: ["DeleteTagApiService"]
    }
  );
export default useDeleteTagApiService;